import React, { Component } from 'react';
import Modal from 'react-modal';

export default class FormModalWrapper extends Component {
    static defaultProps = {
        title: '',
        onClose: () => {}
    };

    render() {
        return (
            <div className="modal-wrapper">
                <Modal {...this.props}
                    isOpen={this.props.open}
                       style={{overlay: {padding: 0, zIndex: 100, borderRadius: '4px'}, content: {height: 'fit-content'}}}
                       showCloseIcon={false}>
                    <div className="modal-card">
                        <header className="modal-card-head">
                            <p className="modal-card-title">{this.props.title}</p>
                            <button className="delete"
                                    aria-label="close"
                                    onClick={this.props.onClose}
                            />
                        </header>
                        {this.props.children}
                    </div>
                </Modal>
            </div>
        );
    }
}